const DynamicShelf = () => {
  var $box = $('[data-dynamic-shelf-url]');
  function loadProducts(element) {
    const $element = $(element);
    const url = $element.attr('data-dynamic-shelf-url');
    try {
      $.get(url).then(function (html) {
        var $html = $('<div>' + html.replace(/<script[^>]*>(?:(?!<\/script>)[^])*<\/script>/g, '') + '</div>');
        var $shelfs = $html.find('.shelf');
        $element.html('');
        $shelfs.each(function (i, shelfBox) {
          var $shelfBox = $(shelfBox);
          var $ul = $shelfBox.find('> ul').clone();
          var $slider = $('<div class="splide"></div>');
          $ul.addClass('splide__list');
          $ul.find('.helperComplement').remove();
          $ul.find('> li').addClass('splide__slide');
          $slider.html($('<div class="splide__track"></div>').html($ul));
          $shelfBox.find('> ul').replaceWith($slider);
          $element.append($shelfBox);
          var slider = window.storeTheme.helpers.slider($slider.get(0), {
            perPage: 4,
            breakpoints: { 992: { perPage: 2 } },
          });
          slider.mount();
          $slider.addClass('slider-ready');
          $(window).trigger('shelf.newItemsLoaded');
        });
      });
    } catch (err) {
      $element.html('');
    }
  }

  $box.each((i, e) => {
    const $e = $(e);
    $e.data('lazyload-script', () => {
      loadProducts(e);
    });
    $e.addClass('lazyload');
    $e.html(window.storeTheme.helpers.loader.getHtmlLoader());
  });
};

DynamicShelf();

export default {};
